import React, {FC} from 'react';
import Section from '../../../components/section';
import {PageHero} from '../../../components/page-hero';
import Layout from '../../../components/layout/layout';
import DiscoverWhis from '../../../components/tools-api-requests/discover-whois';
import Breadcrumb from '../../../components/breadcrumb';

const ApiDocumentationWHOIS: FC = () => {
  return (
    <Layout>
      <PageHero title="" titleSmall minHeight id="seo_home_area_automations">
        <Breadcrumb
          items={[
            {
              to: `/automations`,
              name: 'Automations',
              active: false,
            },
            {
              to: `/automations/built-in-automations`,
              name: "Built-in automations",
              active: false,
            },
            {
              to: `/automations/research`,
              name: "Research",
              active: false,
            },
            {
              to: `/automation/discover-whois/`,
              name: "Discover WHOIS",
              active: false,
            },
            {
              to: `/automation/discover-whois/api-documentation`,
              name: "API documentation",
              active: true,
            },
          ]}
        />
      </PageHero>
      <PageHero title="Discover WHOIS API documentation" subtitle="This page provides API documentation for Discover WHOIS" titleSmall minHeight id="seo_home_area_automations"></PageHero>

      <Section>
        <DiscoverWhis />
      </Section>
    </Layout>
  );
};

export default ApiDocumentationWHOIS;
